import { createFileRoute } from "@tanstack/react-router";

import { AiAdStudioPage } from "@/features/ai-ad-studio";
import { usePageTitle } from "@/hooks/usePageTitle";
import { requireAlphaFeatureFlag } from "@/lib/posthog-flags";

export const Route = createFileRoute("/_auth/_app-shell/ai-ad-studio/")({
  beforeLoad: requireAlphaFeatureFlag,
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("AI Ad Studio");

  return <AiAdStudioPage />;
}
